import { INITIALS_COLOR_CODES } from '@/shared/constants';
import config from '@/config';

// A user counts as "external" when their email domain doesn't match the org's own
// domain (config.userDomain — the single place to change when retargeting the org).
export const isExternalEmail = email => {
   if (!email) return false;
   return !email.toLowerCase().trim().endsWith(config.userDomain.toLowerCase());
};

export const getHashCode = s => {
   let h = 0;
   for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
   return h;
};

export const getColorCodeInitials = name => {
   if (name) {
      const hashCode = getHashCode(name);
      const code = hashCode % INITIALS_COLOR_CODES.length;
      return INITIALS_COLOR_CODES[Math.abs(code)];
   }
   return '#0376da';
};

const removeEmojis = inputString => {
   // Regular expression to match emojis
   const emojiRegex =
      /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1F004}-\u{1F0CF}\u{1F170}-\u{1F251}\u{2702}]/gu;
   // Use the replace method to replace emojis with the specified text
   const replacedString = inputString.replace(emojiRegex, '');
   return replacedString.trim();
};

export const getInitialsFromName = (name = '') => {
   if (!name) return null;
   const trimmedName = name.trim();
   if (!trimmedName) return null;

   // 1. Try to get initials from alphanumeric parts first
   // We remove emojis and non-alphanumeric chars to see if there's representable text
   const cleanText = removeEmojis(trimmedName)
      .replace(/[^a-zA-Z0-9\s]/g, '')
      .trim();

   if (cleanText) {
      const words = cleanText.split(/\s+/).filter(Boolean);
      if (words.length >= 2) {
         return (words[0][0] + words[1][0]).toUpperCase();
      }
      if (words[0].length >= 2) {
         return words[0].substring(0, 2).toUpperCase();
      }
      return words[0][0].toUpperCase();
   }

   // 2. Fallback to emojis/special characters if no alphanumeric text exists
   // Use spread operator for grapheme-aware splitting (handles multi-byte emojis)
   const graphemes = [...trimmedName.replace(/\s+/g, '')];
   if (graphemes.length >= 2) {
      return (graphemes[0] + graphemes[1]).toUpperCase();
   }
   return graphemes[0]?.toUpperCase() || null;
};
